import React, { Fragment, Suspense } from "react";
import { CanonicalUrl } from "@genericComponents/Canonical.js";
import { useGenericStore } from "@customHooks/useGenericStore.js";
import { GetFirstResult } from "@genericComponents/SFW.js";
import { NONCE, UI_URL } from "@data/GlobalData.js";
const useGetPageInfo = await import("@customHooks/useGetPageInfo.js").then(
  (mod) => mod.useGetPageInfo,
);
const RenderContent = ({ list, productCode, languageCode }) => {
  const pageInitData = useGenericStore(list.state, list.defaultData());
  const pageData = GetFirstResult(pageInitData);
  return (
    <Fragment>
      <title>{pageData?.Title}</title>
      <CanonicalUrl
        urlParam={pageData?.Url}
        canonicalParam={pageData?.CanonicalUrl}
      />
      <meta property="og:title" content={pageData?.Title} />
      <meta name="twitter:title" content={pageData?.Title} />
      <meta name="description" content={pageData?.Description} />
      <meta property="og:description" content={pageData?.Description} />
      <meta name="twitter:description" content={pageData?.Description} />
      <meta property="og:image" content={pageData?.Image} />
      <meta property="og:image:secure_url" content={pageData?.Image} />
      <meta name="twitter:image" content={pageData?.Image} />
      <meta property="og:url" content={pageData?.Url} />
      <meta property="og:site_name" content={productCode} />
      <link
        rel="alternate"
        type="text/markdown"
        title={pageData?.Title}
        href={`${pageData?.Url}${pageData?.Url.slice(-1) === "/" ? "" : "/"}llms.txt`}
      />
      <script type="application/ld+json" nonce={NONCE}>
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "WebPage",
          "@id": pageData?.Url,
          url: pageData?.Url,
          name: pageData?.Title,
          description: pageData?.Description,
          keywords: pageData?.Tags
            ? pageData?.Tags.trim().replace(/, /g, ",").split(",")
            : [],
          isPartOf: {
            "@type": "WebSite",
            "@id": `${UI_URL}/${productCode.toLowerCase()}/${languageCode}`,
            name: productCode.toUpperCase(),
            url: `${UI_URL}/${productCode.toLowerCase()}/${languageCode}`,
          },
          inLanguage: languageCode,
          datePublished: pageData?.ModifiedDate ? pageData?.ModifiedDate : null,
          dateModified: pageData?.ModifiedTagDate
            ? pageData?.ModifiedTagDate
            : null,
        })}
      </script>
    </Fragment>
  );
};
const Headers = () => {
  const pageInfo = useGetPageInfo();
  return (
    <Suspense fallback={<Fragment />}>
      <RenderContent
        productCode={pageInfo.productCode}
        languageCode={pageInfo.languageCode}
        list={pageInfo.list}
      />
    </Suspense>
  );
};
export default Headers;
